/**
 * P0 Feedback API
 * Endpoints for in-app feedback system
 */
import axiosInstance from './axiosInstance';

const BASE = '/core/feedback/';

export const feedbackApi = {
  /**
   * Get list of feedback submissions
   * @returns {Promise} List of user's feedback
   */
  list: () => 
    axiosInstance.get(BASE).then((r) => r.data),

  /**
   * Get single feedback by ID
   * @param {string} id - Feedback ID
   * @returns {Promise} Feedback details
   */
  get: (id) => 
    axiosInstance.get(`${BASE}${id}/`).then((r) => r.data),

  /**
   * Submit feedback
   * @param {Object} data - Feedback data
   * @param {string} data.feedback_type - Type: 'bug', 'feature_request', 'general', 'support'
   * @param {string} data.subject - Subject line
   * @param {string} data.message - Feedback message
   * @param {string} data.priority - Priority: 'low', 'medium', 'high', 'urgent'
   * @param {string} data.page_url - Optional: Page URL where feedback was submitted
   * @returns {Promise} Created feedback
   */
  create: (data) => 
    axiosInstance.post(BASE, data).then((r) => r.data),

  /**
   * Update feedback
   * @param {string} id - Feedback ID
   * @param {Object} data - Updated feedback data
   * @returns {Promise} Updated feedback
   */
  update: (id, data) => 
    axiosInstance.patch(`${BASE}${id}/`, data).then((r) => r.data),

  /**
   * Delete feedback
   * @param {string} id - Feedback ID
   * @returns {Promise} Deletion confirmation
   */
  delete: (id) => 
    axiosInstance.delete(`${BASE}${id}/`).then((r) => r.data),
};

export default feedbackApi;

